import { HttpClient } from '@/core/utils/httpClient'
import { TUser } from '@/modules/session/models/User.model'

export class UserRepository extends HttpClient {
  async getMe(): Promise<TUser> {
    return await this.get('/user/me')
  }

  async switchPark(parkId: string) {
    return await this.get(`/user/switch_park/${parkId}`)
  }
}
